/** @format */

import { observable, action, computed } from 'mobx';
import database, { auth } from '../firebase/config';
import ResourceStore from './classes/ResourceStore';
import RequestsStore from './RequestsStore';
import ClientsStore from './ClientsStore';
import CarPartsStore from './CarPartsStore';
import SalesStore from './SalesStore';
import CarsStore from './CarsStore';
import NotificationsStore from './NotificationsStore';

class UserStore extends ResourceStore {
  @observable user = {};
  @observable ref = `users`;
  @observable defaultItem = {
    uid: null,
    name: '',
    surname: '',
    email: '',
    password: '',
    isAdmin: false,
    isExternal: false,
    telephone: '',
    demolition: false,
    whZone: 'all'
  };
  @observable tableKeys = [
    { label: 'NOME', prop: 'name' },
    { label: 'COGNOME', prop: 'surname' },
    { label: 'EMAIL', prop: 'email' },
  ];
  @observable filter = {
    status: 'all',
    rules: {
      all: { label: 'Tutti', name: 'all', value: null },
      ADMIN_USERS: { label: 'Amministratori', name: 'isAdmin', value: true },
      REGULAR_USERS: { label: 'Utenti', name: 'isAdmin', value: false },
    },
  };
  @observable search = {
    value: '',
    attributes: ['name', 'surname', 'email', 'telephone'],
  };

  /**
   * Setta l'utente attualemnte loggato e fetcha le altre risorse
   */
  @action fetchUser() {
    auth.onAuthStateChanged(user => {
      if (!user) {
        return (this.user = null);
      }
      const userRef = database.ref('users/' + user.uid);
      userRef.on('value', userSnap => {
        const userInfo = { ...userSnap.val(), uid: userSnap.key, whZone: 'all' };
        this.user = userInfo;
        NotificationsStore.fetchNotifications();
      });

      RequestsStore.fetchReqChannels();
      RequestsStore.fetchRequests();
      ClientsStore.fetchClients();
      CarPartsStore.fetchWhZones();
      CarPartsStore.fetch();
      CarsStore.fetchAllCars();
      SalesStore.fetchSales();
      this.fetch();
    });
  }

  /**
   * Setta la location dell'utente
   */
  @action setLocation = location => {
    this.user.location = location;
  };

  /**
   * Cambia il ruolo dell'utente
   */
  @action changeRole = selection => {
    this.user.role = selection.value;
  };

  /**
   * Restituisce true se l'utente è correttamente settato
   * @return {Boolean}
   */
  @computed get authStat() {
    return this.user && this.user.uid;
  }

  /**
   * Restituisce il nome intero dell'utente
   * @return {String}
   */
  @computed get userFullName() {
    return `${this.user.name} ${this.user.surname}`;
  }

  /**
   * Restituisce true se l'utente è amministratore
   * @return {Boolean}
   */
  @computed get isAdmin() {
    return this.user.isAdmin;
  }

  /**
   * Restituisce true se l'utente ha i ruolo seller
   * @return {Boolean}
   */
  @computed get isSeller() {
    return this.user.role === 'seller';
  }

  /**
   * Restituisce true se l'utente ha il ruolo warehouse
   * @return {Boolean}
   */
  @computed get isWarehouse() {
    return this.user.role === 'warehouse';
  }

  /**
   * Restituisce il ruolo dell'utente
   * @return {String}
   */
  @computed get roleIt() {
    let roleIt = null;
    switch (true) {
      case this.user.role === 'seller':
        roleIt = 'Venditore';
        break;
      case this.user.role === 'warehouse' && this.user.demolition === true:
        roleIt = 'Magazziniere Autodemolizione';
        break;
      case this.user.role === 'warehouse' && this.user.demolition === false:
        roleIt = 'Magazziniere';
        break;
      case this.user.role === 'admin' && this.user.demolition === false:
        roleIt = 'Amministratore';
        break;
      default:
        roleIt = null;
    }
    return roleIt;
  }
}

export default new UserStore();
